/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { SectionLoader } from "../../../../../components/PageLoader";
import EmptyState from "../../../../../components/EmptyState";
import { getJobOffersAction } from "../../../../../redux/actions/insightActions";
import ReferralJobCard from "./ReferralJobCard";
import RecruiterJobCard from "./RecruiterJobCard";
import CustomButton from "../../../../../components/CustomButton";
import SearchInput from "../../../../../components/CustomSearchInput";
import { InputAdornment, IconButton } from "@material-ui/core";
import { SearchIcon } from "../../../../../components/CustomIcons";

const General = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [state, setState] = useState({
    tooLong: true,
    noApplication: false,
    notAccepting: false,
    other: false,
  });

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const {
    jobOffers: { jobs },
  } = useSelector(({ insight }) => insight);

  // console.log("Jobs", jobs);

  const handleSearchSubmit = () => {
    setSearch(searchInput);
  };

  // Reset to page 1 when search changes
  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  useEffect(() => {
    const fetchJobs = async () => {
      setLoading(true);
      const response = await getJobOffersAction(dispatch, currentPage, perPage, search);
      if (response && response.payload) {
        // Extract pagination metadata from response
        setTotalPages(response.payload.total_pages || 1);
        setTotalCount(response.payload.total_count || 0);
        setPerPage(response.payload.per_page || 10);
      }
      setLoading(false);
    };
    fetchJobs();
  }, [dispatch, currentPage, perPage, search]);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const openEditDialog = () => {
    setOpenEdit(true);
  };

  const closeEditDialog = () => {
    setOpenEdit(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { tooLong, noApplication, notAccepting, other } = state;

  const jobCards = () => {
    return jobs && jobs[0] ? (
      jobs
        .map((job) =>
          job.isToRefTimeLineOrToHireRecruter === "1" ? (
            <ReferralJobCard
              key={job.id}
              job={job}
              handleClick={handleClick}
              anchorEl={anchorEl}
              handleClose={handleClose}
              openDialog={openDialog}
              closeDialog={closeDialog}
              openEditDialog={openEditDialog}
              closeEditDialog={closeEditDialog}
              tooLong={tooLong}
              handleChange={handleChange}
              noApplication={noApplication}
              notAccepting={notAccepting}
              other={other}
              open={open}
              openEdit={openEdit}
            />
          ) : (
            <RecruiterJobCard
              key={job.id}
              job={job}
              handleClick={handleClick}
              anchorEl={anchorEl}
              handleClose={handleClose}
              openDialog={openDialog}
              closeDialog={closeDialog}
              openEditDialog={openEditDialog}
              closeEditDialog={closeEditDialog}
              tooLong={tooLong}
              handleChange={handleChange}
              noApplication={noApplication}
              notAccepting={notAccepting}
              other={other}
              open={open}
              openEdit={openEdit}
            />
          )
        )
    ) : (
      <EmptyState text="you have not posted any job" />
    );
  };

  return (
    <div className="position-relative w-100">
      <div style={{ marginBottom: "16px" }}>
        <SearchInput
          handleChange={(e) => {
            setSearchInput(e.target.value);
          }}
          value={searchInput}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleSearchSubmit();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleSearchSubmit} size="small">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
      {loading && <SectionLoader />}
      {jobCards()}

      {/* Pagination Controls */}
      {!loading && jobs && jobs.length > 0 && totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center mt-4 mb-4 px-3">
          <div className="co-gray small-text">
            Showing {(currentPage - 1) * perPage + 1} -{" "}
            {Math.min(currentPage * perPage, totalCount)} of {totalCount} jobs
          </div>
          <div className="d-flex align-items-center">
            <CustomButton
              text="Previous"
              handleClick={() =>
                setCurrentPage((prev) => Math.max(1, prev - 1))
              }
              disabled={currentPage === 1 || loading}
              backgroundColor={
                currentPage === 1 ? "#e0e0e0" : "var(--primary-color)"
              }
              color={currentPage === 1 ? "#999" : "#fff"}
              additionalClass="px-3 py-1 mx-1"
            />
            <span
              className="mx-3 co-gray"
              style={{
                whiteSpace: "nowrap",
                minWidth: "80px",
                textAlign: "center",
              }}
            >
              Page {currentPage} of {totalPages}
            </span>
            <CustomButton
              text="Next"
              handleClick={() =>
                setCurrentPage((prev) => Math.min(totalPages, prev + 1))
              }
              disabled={currentPage === totalPages || loading}
              backgroundColor={
                currentPage === totalPages ? "#e0e0e0" : "var(--primary-color)"
              }
              color={currentPage === totalPages ? "#999" : "#fff"}
              additionalClass="px-3 py-1 mx-1"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default General;
